require("./bootstrap");

import { createInertiaApp } from "@inertiajs/vue2";
import Vue from "vue";
import Vuetify from "vuetify/lib";

import Echo from "laravel-echo";
import Pusher from "pusher-js";

import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

//import VueSignaturePad from "vue-signature-pad";
import { VueMasonryPlugin } from "vue-masonry";
import VCurrencyField from "v-currency-field";
import Trend from "vuetrend";
import LoadScript from "vue-plugin-load-script";
import VueCropper from "vue-cropperjs";
import VueDOMPurifyHTML from "vue-dompurify-html";
//import VSnow from "vsnow";

import { VTextField } from "vuetify/lib";
import VueApexCharts from "vue-apexcharts";
import { router } from "@inertiajs/vue2";

import { datadogRum } from "@datadog/browser-rum";

import "animate.css/animate.min.css";
import "cropperjs/dist/cropper.css";
import "../css/app.css";
import axios from "axios";

if (window.Laravel.production) {
    const ignoreList = [];

    if (!ignoreList.includes(window.Laravel.user?.email) && window.Laravel) {
        datadogRum.init({
            applicationId: "c9e41979-e70c-45e9-ba76-5ebd569c9c7d",
            clientToken: "pube5aa28c305fecef7121e15d7e17cf155",
            site: "us5.datadoghq.com",
            service: "soli",
            env: "production",
            // Specify a version number to identify the deployed version of your application in Datadog
            // version: '1.0.0',
            sessionSampleRate: 100,
            premiumSampleRate: 100,
            trackUserInteractions: true,
            defaultPrivacyLevel: "allow",
        });

        datadogRum.setUser({
            id: window.Laravel.user?.id,
            name: window.Laravel.user?.name,
            email: window.Laravel.user?.email,
            session_id: window.Laravel.session_id,
        });

        datadogRum.startSessionReplayRecording();
    }
}

window.Pusher = Pusher;
window.Echo = new Echo({
    broadcaster: "pusher",
    key: "ebe655cc5d53796e8813",
    cluster: "us2",
    forceTLS: true,
});

Vue.use(LoadScript);
Vue.use(Trend);
//Vue.use(VSnow);
//Vue.use(VueSignaturePad);
Vue.use(VueMasonryPlugin);
Vue.use(VueApexCharts);
Vue.component(VueCropper);
Vue.use(VueDOMPurifyHTML);

Vue.component("v-text-field", VTextField);
Vue.component("apexchart", VueApexCharts);

Vue.use(VCurrencyField, {
    locale: "en",
    decimalLength: 2,
    autoDecimalMode: true,
    /*min: null,
    max: null,
    defaultValue: 0,*/
    valueAsInteger: false,
    allowNegative: false,
});

//Vue.use(plugin);

Vue.mixin({ methods: { route } });

// Global methods
Vue.mixin({
    methods: {
        can(permission) {
            if (!this.$page.props.auth.user) return null;
            return this.$page.props.auth.permissions.includes(permission);
        },
        is(role) {
            if (!this.$page.props.auth.user) return null;
            return this.$page.props.auth.roles.includes(role);
        },
        closeModal(method, timeout = 300) {
            if (!method) return;
            setTimeout(() => {
                method();
            }, timeout);
        },
        throttle(method, wait = 300) {
            let throttled = false;
            return function (...args) {
                if (!throttled) {
                    method(args);
                    throttled = true;
                    setTimeout(() => {
                        throttled = false;
                    }, wait);
                }
            };
        },
        debounce(method, wait = 300) {
            let timer;
            return function (value, cancel = false) {
                if (cancel) {
                    clearTimeout(timer);
                    return;
                }
                if (timer) {
                    clearTimeout(timer);
                }
                timer = setTimeout(() => {
                    method(value);
                }, wait);
            };
        },
        formatUnitAmount(value) {
            return `$${(value / 100).toFixed(2)}`;
        },
        formatCurrency(value) {
            return `$${Number(value).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}`;
        },
        /*sessionHelper(key, value = null) {
            this.$inertia.post(
                "/session",
                { key, value },
                {
                    preserveState: true,
                    preserveScroll: true,
                }
            );
        },*/
    },
});
//Vue.use(PortalVue);
Vue.use(Vuetify);

Vue.prototype.$log = console.log;
Vue.prototype.$table = console.table;

Vue.prototype.moment = moment;

createInertiaApp({
    title: (title) => `${title ? title + " - " : ""}Musicologie`,
    resolve: (name) => require(`./Pages/${name}`),
    setup({ el, App, props, plugin }) {
        Vue.use(plugin);
        let vue = new Vue({
            vuetify: new Vuetify({
                icons: {
                    iconfont: "md",
                },
                theme: {
                    themes: {
                        light: {
                            primary: "#2aabe6",
                            secondary: "#f38c68",
                            accent: "#228cbd",
                            //success: "#48ad24",
                            success: "#32c090",
                            error: "#b71c1c",
                            dark: "#4b6876",
                            warning: "#fbbd23",
                            "soli-green": "#48ad24",
                            "soli-red": "#e07b7b",
                            dim: "#e5e7eb",
                        },
                    },
                },
            }),
            data: {
                networkError: false,
                loading: false,
                channels: initChannels(props.props.initialPage.props),
            },
            render: (h) => h(App, props),
        }).$mount(el);
        document.addEventListener("inertia:exception", (event) => {
            vue.networkError = true;
        });
        router.on("start", (event) => {
            vue.loading = true;
        });
        router.on("finish", (event) => {
            vue.loading = false;
        });
    },
});

const requireComponent = require.context("@/Components/Base", true, /\.vue$/);

for (const file of requireComponent.keys()) {
    const componentConfig = requireComponent(file);
    const name = file
        .replace(/index.js/, "")
        .replace(/^\.\//, "")
        .replace(/\.\w+$/, "");
    const componentName = upperFirst(camelCase(name));

    Vue.component(
        `${componentName}`,
        componentConfig.default || componentConfig
    );
}

const initChannels = (props) => {
    const authUser = props.auth.user;
    if (!authUser) return {};

    const crmMode = props.crmMode;
    const lobbyId = authUser.selected_location.user?.id;
    const authId = authUser.id;

    return {
        auth: window.Echo.private(`App.Models.User.${authId}`),
        lobby:
            crmMode && lobbyId
                ? window.Echo.private(`App.Models.User.${lobbyId}`)
                : null,
    };
};
